import { MutationTree } from 'vuex'
import { KnowledgeState } from './state'
import { KnowledgeBase, KnowledgeBlock } from '@/models/knowledge'

export enum KnowledgeMutation {
  SetBases = 'SetBases',
  SetSelectedBaseId = 'SetSelectedBaseId',
  SetBlocks = 'SetBlocks',
  SetOpenSectionId = 'SetOpenSection',
  SetOpenBlockId = 'SetOpenBlock',
}

export type KnowledgeMutationSetBasesPayload = {
  data: KnowledgeBase[]
}

export type KnowledgeMutationSelectBasePayload = {
  data: string
}

export type KnowledgeMutationSetBlocks = {
  data: Record<string, KnowledgeBlock[]>
}

export const mutations: MutationTree<KnowledgeState> = {
  [KnowledgeMutation.SetBases](
    state,
    payload: KnowledgeMutationSetBasesPayload,
  ) {
    state.bases = payload.data
  },
  [KnowledgeMutation.SetSelectedBaseId](
    state,
    payload: KnowledgeMutationSelectBasePayload,
  ) {
    state.selectedBaseId = payload.data
  },
  [KnowledgeMutation.SetBlocks](state, payload: KnowledgeMutationSetBlocks) {
    state.blocks = payload.data
  },
  [KnowledgeMutation.SetOpenSectionId](state, payload: string[]) {
    state.openSectionIds = payload
  },
  [KnowledgeMutation.SetOpenBlockId](state, payload: string[]) {
    state.openBlockIds = payload
  },
}
